<template>
        <div style="width:100%;text-align:center;">
            <iframe src=""></iframe>
        </div>
</template>

<script>
    import modalHelper from "@/mixins/modalHelper";
    import _don from "@/libs/doson";

    const formModal = {
        id:null,
        reportNo:null,
        reportUuid:null,
        department:{id:null},
        equipmentId:null,
        archiveInfo:null,
        assayType:0,
        perfermance:0,
        highDis:0,
        opacimeterType:null,
        opacimeterNo:null,
        opacimeterManu:null,
        timerType:null,
        timerNo:null,
        timerManu:null,
        vsaType:null,
        vsaNo:null,
        vsaManu:null,
        lightfilterType:null,
        lightfilterNo:null,
        lightfilterManu:null,
        temperature:null,
        elevation:null,
        pressure:null,
        humidity:null,
        examMethod:0,
        smokeVal1:null,
        smokeVal2:null,
        smokeVal3:null,
        smokeVal:null,
        pic1:null,
        pic2:null,
        pic3:null,
        examDate:null,
        expireDate:null,
        examAddress:null,
        status:0
    };

    export default {
        name: "report-print",
        mixins: [],
        components: {
        },

        data() {
            return {
                dataSource:{}
            }
        },
        mounted() {
            let th = this;
            window.addEventListener("message", function(event){
                console.log(event);
                var d = event.data;
                if (d.cmd=='print') {
                    window.print()
                } else {
                    th.dataSource = d.data
                }
            },false);
        },
        methods: {
            init() {

            },
            setFormData() {
                _don.cloneWithModal(formModal, this.formData, this.dataSource);
            },
            maxSmoke() {
                if (!this.dataSource.smokeVal) {
                    return ''
                }
                return Math.max(this.dataSource.smokeVal1,this.dataSource.smokeVal2,this.dataSource.smokeVal3)
            },
            afName() {
                if (!this.dataSource.archiveInfo || !this.dataSource.archiveInfo.afterProcess) {
                    return '无'
                }
                //0=无 1=SCR 2=DPF 3=POC 4=DOC
                let af = this.dataSource.archiveInfo.afterProcess;
                return ['无','SCR','DPF','POC','DOC'][af]
            },
            startTime(end) {
                if (end) {
                    return this.formatDate(new Date(new Date(end).getTime()-3*60*1000), 'hh:mm:ss')
                }
            },
            endTime(end) {
                if (end) {
                    return this.formatDate(new Date(end), 'hh:mm:ss')
                }
            },
            formatDate(date, fmt) {
                if (/(y+)/.test(fmt)) {
                    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
                }
                let o = {
                    'M+': date.getMonth() + 1,
                    'd+': date.getDate(),
                    'h+': date.getHours(),
                    'm+': date.getMinutes(),
                    's+': date.getSeconds()
                };
                for (let k in o) {
                    if (new RegExp(`(${k})`).test(fmt)) {
                        let str = o[k] + '';
                        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length));
                    }
                }
                return fmt;
            },
            myPrint() {
                var newWin= window.open("");//新打开一个空窗口
                newWin.document.body.innerHTML = this.$refs.printContent.innerHTML;
                newWin.document.close();//在IE浏览器中使用必须添加这一句
                newWin.focus();//在IE浏览器中使用必须添加这一句
                newWin.print();//打印
                newWin.close();
            }
        },
        computed: {

        },
        watch:{

        }
    }
</script>

<style scoped lang="less">
    #printArea{
        width:210mm;
        height:891mm;

        .content{
            padding:0 5mm;

            .page{
                width:100%;
                height:297mm;
                display: flex;
                flex-direction: column;
                align-items: center;
                font-family: 宋体;
                color:#000000;

                div{
                    box-sizing: border-box;
                }
            }

            .page1{
                .row1{
                    width:70%;
                    font-size:28px;
                    font-weight:bold;
                }
                .row2{
                    font-size:48px;
                    font-family: 黑体;
                }

                .row3{
                    width:80%;
                    padding-right:10%;
                    font-size:18px;
                    display: flex;

                    .val{
                        flex:1;
                        border-bottom:1px solid #000000;
                    }
                }

                .row4{
                    width:70%;
                    font-size:14px;
                    font-weight: bold;
                    line-height:21px;
                }
            }

            .page2{
                .table-body {
                    padding-top: 20px;
                    width:96%;
                }
                .table-body h1 {
                    font-size: 24px;
                    text-align: center;
                }
                .table-row td {
                    border: 1.5px solid #000000;
                    text-align: center;
                    padding: 5px;
                    border-top: none;
                }
                .table-row {
                    border-collapse: collapse;
                    border: 1.5px solid #000000;
                    width: 100%;
                    border: none;
                }
                .table-body-main {
                    margin-top: 20px;
                }
                .table-body-main > .table-row:first-child {
                    border-top: 1.5px solid #000000;
                }
                .table-c {
                    margin-top: -1px;
                }

            }

            .page3{
                padding:5mm;
                align-items: flex-start;

                h3{
                    font-weight: normal;
                }
                img{
                    height:70mm;
                }
                div{
                    height:70mm;
                }
            }
        }


    }
</style>
